module.exports = __webpack_public_path__ + "fec9d147a923ce7136c0f18d26e0cf58.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/wrinkles/wrinkles-1a.jpg
 ** module id = 447
 ** module chunks = 0
 **/